var _excluded = ["children"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/Web-Component-Library?node-id=0%3A1088
import { Button, Menu, MenuButton, MenuList } from '@chakra-ui/react';
import React from 'react';
import { ChevronDownIcon } from "../Icons/Action/CheveronDown";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Dropdown = _ref => {
  var {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  function getSelectedChild(children) {
    return React.Children.toArray(children).find(child => /*#__PURE__*/React.isValidElement(child) && child.props.value === props.value);
  }

  function dropdownText() {
    var dropdownText = props.placeholder || '';

    if (props.value != null) {
      var selectedItem = getSelectedChild(children);

      if (selectedItem) {
        var _props;

        dropdownText = selectedItem == null ? void 0 : (_props = selectedItem.props) == null ? void 0 : _props.children.toString();
      } else {
        dropdownText = props.value.toString();
      }
    }

    return dropdownText;
  }

  return /*#__PURE__*/_jsxs(Menu, {
    gutter: 4,
    matchWidth: true,
    flip: false,
    strategy: "fixed",
    children: [/*#__PURE__*/_jsx(MenuButton, {
      as: Button,
      minWidth: props.width,
      variant: "outline",
      border: "1px solid",
      borderColor: "tertiary.700",
      borderRadius: "small",
      _expanded: {
        color: 'neutral.500',
        border: '2px solid',
        borderColor: 'primary.500',
        bg: 'white.900'
      },
      _focus: {
        color: 'neutral.500',
        border: '2px solid',
        borderColor: 'primary.500',
        bg: 'white.900',
        boxShadow: 'outline'
      },
      _hover: {
        color: 'neutral.500'
      },
      _active: {
        bg: 'white.900'
      },
      leftIcon: props.icon,
      leftIconSpacing: "24px",
      textColor: "neutral.500",
      textAlign: "left",
      textStyle: "body-normal-medium",
      rightIcon: /*#__PURE__*/_jsx(ChevronDownIcon, {
        color: 'black',
        fontSize: '4xl'
      }),
      children: dropdownText()
    }), /*#__PURE__*/_jsx(MenuList, {
      pt: 0,
      pb: 0,
      maxHeight: '25vh',
      boxShadow: "popOut",
      overflowY: 'auto',
      children: children
    })]
  });
};
//# sourceMappingURL=Dropdown.js.map